import React from 'react'
import Popover from '@material-ui/core/Popover'
import {FiSettings} from 'react-icons/fi'
import Button from '@material-ui/core/Button'
import useStyles from './BarcodePopButton.styles'

function BarcodePopButton({children}) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  function handleClick(event) {
    setAnchorEl(event.currentTarget)
  }

  function handleClose() {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, {closePopup: handleClose})
  )

  return (
    <div className="float-right mr-4">
      <Button
        className="bg-asset-header"
        classes={{root: classes.btnRoot}}
        aria-describedby={id}
        onClick={handleClick}
      >
        {<FiSettings size={22} />}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableScrollLock={true}
      >
        <div className={classes.typography}>{childrenWithProps}</div>
      </Popover>
    </div>
  )
}

export default BarcodePopButton
